import { render, staticRenderFns } from "./Co15Page.vue?vue&type=template&id=213f86f5"
import script from "./Co15Page.vue?vue&type=script&lang=js"
export * from "./Co15Page.vue?vue&type=script&lang=js"
import style0 from "./Co15Page.vue?vue&type=style&index=0&id=213f86f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports